export default "__VITE_ASSET__d6f351b0__"